/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import BaseSymbol from './BaseSymbols';

/**
 * Utility class responsible for generating CIM-based cluster symbols.
 * 
 * The `createClusterMarkerV2` method constructs a `CIMPointSymbol` composed of a vector marker
 * with predefined geometry and styling. This is used to visually represent cluster points
 * on a map with customizable size and base color.
 */
class ClusterSymbolV2 implements Partial<BaseSymbol> {
  createClusterMarkerV2(size: number, color: number[]) {
    return {
      type         : 'CIMPointSymbol',
      symbolLayers : [
        {
          type               : 'CIMVectorMarker',
          enable             : true,
          anchorPointUnits   : 'Relative',
          dominantSizeAxis3D : 'Z',
          size               : size,
          billboardMode3D    : 'FaceNearPlane',
          frame              : {
            xmin : 0,
            ymin : 0,
            xmax : 74,
            ymax : 74
          },
          markerGraphics : [
            {
              type     : 'CIMMarkerGraphic',
              geometry : {
                rings : [
                  [
                    [37, 1.5], [43.9, 2.2], [50.6, 4.2], [56.7, 7.5],
                    [62.1, 11.9], [66.5, 17.3], [69.8, 23.4], [71.8, 30.1],
                    [72.5, 37], [71.8, 43.9], [69.8, 50.6], [66.5, 56.7],
                    [62.1, 62.1], [56.7, 66.5], [50.6, 69.8], [43.9, 71.8],
                    [37, 72.5], [30.1, 71.8], [23.4, 69.8], [17.3, 66.5],
                    [11.9, 62.1], [7.5, 56.7], [4.2, 50.6], [2.2, 43.9],
                    [1.5, 37], [2.2, 30.1], [4.2, 23.4], [7.5, 17.3],
                    [11.9, 11.9], [17.3, 7.5], [23.4, 4.2], [30.1, 2.2],
                    [37, 1.5]
                  ]
                ]
              },
              symbol : {
                type         : 'CIMPolygonSymbol',
                symbolLayers : [
                  {
                    type   : 'CIMSolidFill',
                    enable : true,
                    color  : [...color, 255]
                  },
                  {
                    type       : 'CIMSolidStroke',
                    enable     : true,
                    capStyle   : 'Round',
                    joinStyle  : 'Round',
                    miterLimit : 10,
                    width      : 6,
                    color      : [255, 255, 255, 255]
                  }
                ]
              }
            }
          ],
          scaleSymbolsProportionally : true,
          respectFrame               : true,
          clippingPath               : {
            type         : 'CIMClippingPath',
            clippingType : 'Intersect',
            path         : {
              rings : [
                [
                  [0, 0], [74, 0], [74, 74], [0, 74], [0, 0]
                ]
              ]
            }
          }
        }
      ],
      animations : []
    };
  }
}

export default new ClusterSymbolV2();
